// A hand-set 'YYYY-MM-DD' content date as an ISO timestamp (09:00 SGT, same
// convention as PRICES_REVIEWED on the aircon price page). Use it for
// dateModified / article:modified_time instead of getArticleDateTime's
// modifiedDate, which is the build time and so advances on every ISR rebuild
// whether or not the page changed - a freshness signal Google learns to ignore.
export const reviewedIso = (date) => `${date}T09:00:00+08:00`

export const getArticleDateTime = () => {
    const toIsoString = (date) => {
        const tzo = -date.getTimezoneOffset(), dif = tzo >= 0 ? '+' : '-', pad = function (num) {
            return (num < 10 ? '0' : '') + num;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    };
    const dt = new Date();
    const modifiedDate = toIsoString(dt);
    const year = dt.getFullYear();
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[dt.getMonth()];
    return { modifiedDate, month, year };
}